export const testSchoolEmail = (email: string): boolean => {
  return /(\.edu|@campuslush\.com)$/.test(email);
};
